import React from 'react';
import SEO from '../components/SEO';
import '../styles.css';

function NotFoundPage() {
  return (
    <div className="page-container">
      <SEO
        title="Page not found | Virgil"
        description="This page could not be found. Head back to Virgil, the AI writing workspace for screenplays, novels, podcasts, and pitches."
        noindex
      />
      <section className="content-section static-page-section not-found-section">
        <p className="section-eyebrow">Page not found</p>
        <h1 className="page-title">This page has wandered off</h1>
        <p className="page-lead">
          The link may be old, or the page may have moved. You can pick the thread back up from here.
        </p>
        <div className="not-found-actions">
          <a className="cta-button" href="/">Back to the homepage</a>
          <a className="cta-button secondary" href="/pricing">See pricing</a>
          <a className="cta-button secondary" href="/faq">Read the FAQ</a>
        </div>
      </section>
    </div>
  );
}

export default NotFoundPage;
